import { createQuoteSlice } from 'common/stores/redux/Quote';

const adminQuoteSlice = createQuoteSlice('adminQuote');

export const {
    init,
    replace,
    resetPages,
    updateKeyValuePair,
    setNotes,
    addComment,
    updateComment,
    addFolderAttachment,
    removeFolderAttachment,
    addPhoto,
    updateInstructions,
    updateSpecialInstructions,
    initFinancialInformation,
    updateContact,
    addContact,
    removeContact,
    deleteContact,
    update,
} = adminQuoteSlice.actions;

/**
 * Updates the client for an quote, fetching and applying client-specific settings
 * @type {import('@reduxjs/toolkit').AsyncThunk<any, number, {}>}
 */
export const updateClient = adminQuoteSlice.thunks.updateClient;

export default adminQuoteSlice.reducer;
